let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("SQnmN")).then(() => parcelRequire('7KUlu'));